import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import {
  PATIENT_API,
  NewCustomerDTO,
  IPatientTokenPayload,
  ResetResponse,
  ICustomerUser
} from '@care-portals/api-interfaces';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient) {}

  create(newCustomerDTO: NewCustomerDTO) {
    try {
      return this.http
        .post<NewCustomerDTO>(
          environment.api.baseUrl + PATIENT_API.users.base,
          newCustomerDTO
        )
        .pipe(map(() => newCustomerDTO));
    } catch (error) {
      console.error(error);
      throw new Error('Failed to sign up: ' + error);
    }
  }

  get(): Observable<IPatientTokenPayload> {
    try {
      return this.http.get<IPatientTokenPayload>(
        environment.api.baseUrl + PATIENT_API.users.base
      );
    } catch (error) {
      console.error(error);
      throw new Error('Failed to get user: ' + error);
    }
  }

  getCustomerInfo(): Observable<ICustomerUser> {
    try {
      return this.http.get<ICustomerUser>(
        environment.api.baseUrl +
          PATIENT_API.users.base +
          PATIENT_API.users.getCustomerInfo
      );
    } catch (error) {
      console.error('UserService :: getCustomerInfo() Error ', error);
      throw new Error('Failed to get getCustomerInfo: ' + error);
    }
  }

  getStripeDashboardUrl() {
    try {
      return this.http
        .get<{ url: string }>(
          environment.api.baseUrl +
            PATIENT_API.users.base +
            PATIENT_API.users.getStripeDashboardUrl
        )
        .pipe(map(res => res.url));
    } catch (error) {
      console.error(error);
      throw new Error('Failed to get access: ' + error);
    }
  }

  forgotPassword(email: string): Observable<ResetResponse> {
    try {
      return this.http.post<ResetResponse>(
        environment.api.baseUrl +
          PATIENT_API.auth.base +
          PATIENT_API.auth.forgot,
        { email }
      );
    } catch (error) {
      console.error(error);
      throw new Error('Failed to forgot password: ' + error.message);
    }
  }

  validPasswordToken(token: string): Observable<ResetResponse> {
    try {
      const params = new HttpParams({
        fromObject: { token }
      });

      return this.http.get<ResetResponse>(
        environment.api.baseUrl +
          PATIENT_API.auth.base +
          PATIENT_API.auth.reset,
        { params }
      );
    } catch (error) {
      console.error(error);
      throw new Error('Failed to verify token: ' + error.message);
    }
  }

  resetPassword(token: string, password: string): Observable<ResetResponse> {
    try {
      return this.http.post<ResetResponse>(
        environment.api.baseUrl +
          PATIENT_API.auth.base +
          PATIENT_API.auth.reset,
        { token, password }
      );
    } catch (error) {
      console.error(error);
      throw new Error('Failed to reset password: ' + error.message);
    }
  }

  // public getUserDetails(token?: String): Account {
  //   token = token || this.getToken();
  //   let payload;
  //   if (token) {
  //     payload = token.split('.')[1];
  //     payload = window.atob(payload);
  //     return JSON.parse(payload);
  //   } else {
  //     return null;
  //   }
  // }

  // get isLoggedIn():boolean{
  //   const user = this.getUserDetails();
  //   if (user) {
  //     return user.exp > Date.now() / 1000;
  //   } else {
  //     return false;
  //   }  }
}
